<site-header *ngIf="!hideHeader"></site-header>
<div class="site-page container">
    <ng-content></ng-content>
</div>